import webpushRequest from 'src/web-push';


webpushRequest(window.getUserId());
